"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Input } from "@/components/ui/input";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
function LoginForm() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="p-6 bg-primary/10 border border-primary/30 rounded-lg">
        <p className="text-foreground font-semibold mb-2">{successMessage}</p>
        <p className="text-foreground/80 text-sm mb-4">You can now use the chat below.</p>
      </div>;
  }
  return <Form onSubmit={handleSubmit}>
      <div className="space-y-4">
        <FormField control={control} name="email" rules={{
        required: "Email is required",
        pattern: {
          value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
          message: "Please enter a valid email"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="text-foreground">Email</FormLabel>
              <FormControl>
                <Input type="email" placeholder="your@email.com" className="bg-background/50 border-muted/30 text-foreground placeholder:text-foreground/50 focus-ring" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />

        <FormField control={control} name="password" rules={{
        required: "Password is required",
        minLength: {
          value: 6,
          message: "Password must be at least 6 characters"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="text-foreground">Password</FormLabel>
              <FormControl>
                <Input type="password" placeholder="Enter password" className="bg-background/50 border-muted/30 text-foreground placeholder:text-foreground/50 focus-ring" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />

        {submitError && <div className="p-3 bg-destructive/10 border border-destructive/30 rounded-md">
            <p className="text-destructive text-sm">{submitError}</p>
          </div>}
      </div>
    </Form>;
}
export default function Hero() {
  const ref1 = useRevealOnScroll({
    threshold: 0.75,
    once: true
  });
  const ref2 = useRevealOnScroll({
    threshold: 0.75,
    once: true
  });
  return <section className="relative w-full min-h-[90vh] flex items-center bg-contain bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1463994/img/image_5i400s2i.jpg)]">
      {}
      <div className="absolute inset-0 bg-gradient-to-r from-black/90 via-black/70 to-transparent" />

      {}
      <div className="relative z-10 container mx-auto px-6 lg:px-12 max-w-7xl py-16">
        {}
        <div className="mb-12 flex flex-col items-start gap-4">
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1463994/img/image_unric5jy.jpg" alt="Hoosier Open 9-Ball Tour Logo" className="h-20 md:h-24 object-contain" />
          <div>
            <p className="text-2xl md:text-3xl font-display font-bold text-foreground leading-tight">
              Indiana's Premier Competitive Pool Tour
            </p>
            <Link to="https://www.hoosieropen9-balltour.com" newTab className="text-primary hover:text-primary-hover transition-colors font-semibold mt-2 inline-block">
              Visit hoosieropen9-balltour.com
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          {}
          <div ref={ref1.ref} className={`transition-all duration-[var(--duration-fast)] ease-[cubic-bezier(0.4,0,0.2,1)] ${ref1.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
            {}
            <h1 className="font-display text-5xl md:text-6xl lg:text-7xl font-bold text-foreground leading-tight mb-4">
              Live Tournament Action
            </h1>

            {}
            <p className="text-xl md:text-2xl text-foreground/90 mb-8 leading-relaxed">
              Watch the best pocket billiards players compete in real-time. Join the community and experience every break, every shot, every victory.
            </p>

            {}
            <Link to="/LiveStreamPage">
              <Button size="lg" className="bg-primary text-foreground-primary font-semibold px-8 py-6 text-lg rounded-md shadow-medium hover:bg-primary-hover hover:scale-[1.03] hover:shadow-[0_0_8px_hsla(4,95%,52%,0.6)] active:bg-primary-active active:scale-100 transition-all duration-[120ms] ease-out focus-ring">
                Watch Live Now
              </Button>
            </Link>
          </div>

          {}
          <div ref={ref2.ref} className={`transition-all duration-[var(--duration-fast)] ease-[cubic-bezier(0.4,0,0.2,1)] ${ref2.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"} flex flex-col gap-4`}>
            {}
            <div className="bg-surface rounded-lg shadow-strong p-4 border border-border">
              {}
              <div className="w-full aspect-video rounded-md overflow-hidden bg-black">
                <div className="w-full h-full wpstream-player-container" dangerouslySetInnerHTML={{
                __html: '[wpstream_player id="65" ][/wpstream_player]'
              }} />
              </div>
            </div>

            {}
            <FormProvider className="bg-surface rounded-lg shadow-strong p-4 border border-border" formId="hero-login-form" sectionName="hero-section" defaultValues={{
            email: "",
            password: ""
          }} validationRules={{
            email: {
              required: true,
              pattern: "email"
            },
            password: {
              required: true,
              minLength: 6
            }
          }} submitText="Login to Chat" successMessage="Login successful! Welcome to the chat.">
              <div className="flex items-center justify-between mb-4">
                <h3 className="font-display text-lg font-semibold text-foreground">
                  Chat Login
                </h3>
                <div className="flex items-center gap-2">
                  <div className="size-2 bg-accent rounded-full" />
                  <span className="text-sm text-foreground/80">Required</span>
                </div>
              </div>
              <LoginForm />
            </FormProvider>

            {}
            <div className="bg-surface rounded-lg shadow-strong p-4 border border-border">
              <div className="flex items-center justify-between mb-3">
                <h3 className="font-display text-lg font-semibold text-foreground">
                  Live Chat
                </h3>
                <div className="flex items-center gap-2">
                  <div className="size-2 bg-primary rounded-full animate-pulse" />
                  <span className="text-sm text-foreground/80">Active</span>
                </div>
              </div>
              
              {}
              <div className="simple-ajax-chat-container min-h-[300px] rounded-md bg-background/50 p-3 border border-muted/30" dangerouslySetInnerHTML={{
              __html: '[simple-ajax-chat]'
            }} />
            </div>
          </div>
        </div>
      </div>
    </section>;
}